// extracted by mini-css-extract-plugin
export var widgetsColumn = "_4d09997c1351c21b19bae39cf02bb48d-css";
export var widgetsColumn_isDragging = "_4a53294d91120adf2dde1ccea1ca52af-css";
export var widgetsColumn_isDraggingOver = "_17e8a21e845b2e6040fa7291c17c3f21-css";